import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()(() => ({
  container: {
    ...dFlex('initial', 'flex-start'),
    flexDirection: 'column',
    gap: 16,
  },
  wrap: {
    padding: '16px',
    width: '100%',
    ...dFlex('space-between', 'center'),
    flexDirection: 'column',
    height: 'calc(100vh - 92px)',
  },
  // Sky lockup is wide — height-only sizing (was 200×200 for the old square logo).
  logo: {
    height: 56,
    width: 'auto',
  },
}));

export default useStyles;
